import { useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

type Props = {
  delay?: number;
  offset?: number;
};

const useIsSticky = <T extends Element>({ delay = 100, offset = 0 }: Props) => {
  const ref = useRef<T>(null);
  const [isSticky, setIsSticky] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const handleScroll = throttle(() => {
      if (ref.current) {
        const { top } = ref.current.getBoundingClientRect();
        setIsSticky(top <= offset);
      }
    }, delay);

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [delay, offset]);

  return [ref, isSticky] as const;
};

export default useIsSticky;
